// extracted by mini-css-extract-plugin
export default {"container":"DeviceModelRow__container-YWDhK","checkbox":"DeviceModelRow__checkbox-QCDGq","name":"DeviceModelRow__name-_Y2bl"};